import React from "react";

export default ({ children }) => <div className="f5 mb3">{children}</div>;



// WEBPACK FOOTER //
// ./src/components/generic/form/service/Description/index.js